
import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
  input,
  ChangeDetectionStrategy
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MaterialModule } from '../../material.module';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { entityState } from '../../services/jkEntityTypes';


/**
 * CRUD導航工具列基礎組件
 *
 * 提供基礎的CRUD操作和導航功能按鈕，作為其他工具列組件的基礎類別。
 * 此組件提供了標準的資料操作按鈕（新增、編輯、儲存、取消、刪除）和
 * 導航按鈕（首筆、上一筆、下一筆、末筆），並根據當前資料狀態自動管理
 * 按鈕的啟用/停用狀態。
 */
@Component({
  selector: 'app-crudbar-nav',
  templateUrl: './crudbar-nav.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MaterialModule, CommonModule, MatIcon],
})
export class CrudbarNavComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'crudbar-nav';
  programId: string = '';
  isVisible(): boolean {
    const visibleValue = this.visible as unknown;

    if (typeof visibleValue === 'function') {
      return (visibleValue as () => boolean)();
    }

    return visibleValue !== false;
  }

  /** 導航區域是否可見 */
  //navigateVisible: boolean = true;
  navigateVisible = signal(true);

  /** 首筆按鈕是否可見 */
  firstVisible = signal(true);

  /** 首筆按鈕是否禁用 */
  firstDisabled: boolean = false;

  /** 首頁回調函數 */
  cbHome?: () => void;

  /** 返回回調函數 */
  cbBack?: () => void;

  /**
   * 導航到首頁
   * @param $event 事件對象
   */
  goHome($event: any) {
    if (this.cbHome) this.cbHome();
  }

  /**
   * 返回上一頁
   * @param $event 事件對象
   */
  goBack($event: any) {
    if (this.cbBack) this.cbBack();
  }
  /** 首筆記錄回調函數 */
  cbFirst?: () => void;

  /**
   * 導航到首筆記錄
   */
  onFirstRow() {
    if (this.cbFirst) this.cbFirst();
  }

  /** 上一筆按鈕是否可見 */
  previousVisible: boolean = true;

  /** 上一筆按鈕是否禁用 */
  previousDisabled: boolean = false;

  /** 上一筆記錄回調函數 */
  cbPrevious?: () => void;

  /**
   * 導航到上一筆記錄
   */
  onPreviousRow() {
    if (this.cbPrevious) this.cbPrevious();
  }

  /** 下一筆按鈕是否可見 */
  nextVisible: boolean = true;

  /** 下一筆按鈕是否禁用 */
  nextDisabled: boolean = false;

  /** 下一筆記錄回調函數 */
  cbNext?: () => void;

  /**
   * 導航到下一筆記錄
   */
  onNextRow() {
    if (this.cbNext) this.cbNext();
  }

  /** 末筆按鈕是否可見 */
  lastVisible: boolean = true;

  /** 末筆按鈕是否禁用 */
  lastDisabled: boolean = false;

  /** 末筆記錄回調函數 */
  cbLast?: () => void;

  /**
   * 導航到末筆記錄
   */
  onLastRow() {
    if (this.cbLast) this.cbLast();
  }
  /** 編輯並儲存按鈕是否可見 */
  readonly editAndSaveVisible = input<boolean>(false);
  editAndSaveDisabled = signal(false);
  /** 編輯並儲存回調函數 */
  cbEditAndSave?: ($event: any) => Promise<boolean>;

  /**
   * 執行編輯並儲存操作
   * @param $event 事件對象
   */
  async doEditAndSave($event: any) {
    if (this.cbEditAndSave) {
      let bool = await this.cbEditAndSave($event);
      if (bool) {
        alert('儲存成功');
      }
    }
  }

  /**
   * 實體狀態變更處理函數
   * @param state 新的實體狀態
   */
  onStateChanged(state: entityState): void {
    this.setMode(state);
  }
  //cbQuery?: () => void;
  /** 新增回調函數 */
  cbInsert?: () => Promise<void>;

  /** 編輯回調函數 */
  cbEdit?: () => Promise<void>;

  /** 儲存回調函數 */
  cbPost?: (value: any) => Promise<boolean>;

  /** 取消回調函數 */
  cbCancel?: () => void;

  /** 刪除回調函數 */
  cbDelete?: () => Promise<boolean>;

  /** 自訂按鈕1回調函數 */
  cbUser1?: () => void;

  /** 自訂按鈕2回調函數 */
  cbUser2?: () => void;

  /** 自訂按鈕3回調函數 */
  cbUser3?: () => void;

  /** 自訂按鈕4回調函數 */
  cbUser4?: () => void;
  /** 新增按鈕是否可見 */
  public readonly insertVisible = input(true);

  /** 編輯按鈕是否可見 */
  public readonly editVisible = input(true);

  /** 儲存按鈕是否可見 */
  public readonly postVisible = input(true);

  /** 取消按鈕是否可見 */
  public readonly cancelVisible = input(true);

  /** 刪除按鈕是否可見 */
  public readonly deleteVisible = input(true);

  /** 自訂按鈕1是否可見 */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() public user1Visible = false;

  /** 自訂按鈕2是否可見 */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() public user2Visible = false;

  /** 自訂按鈕3是否可見 */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() public user3Visible = false;

  /** 自訂按鈕4是否可見 */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() public user4Visible = false;
  /** 查詢按鈕是否禁用 */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() public queryDisabled = false;

  /** 新增按鈕是否禁用 */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() public insertDisabled = false;

  /** 編輯按鈕是否禁用 */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() public editDisabled = false;

  /** 儲存按鈕是否禁用 */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() public postDisabled = true;

  /** 取消按鈕是否禁用 */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() public cancelDisabled = true;

  /** 刪除按鈕是否禁用 */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() public deleteDisabled = false;

  /** 自訂按鈕1是否禁用 */
  public readonly user1Disabled = input(false);

  /** 自訂按鈕2是否禁用 */
  public readonly user2Disabled = input(false);

  /** 自訂按鈕3是否禁用 */
  public readonly user3Disabled = input(false);

  /** 自訂按鈕4是否禁用 */
  public readonly user4Disabled = input(false);
  /** 自訂按鈕1標題 */
  _userCaption1 = '自訂1';

  /**
   * 設定自訂按鈕1標題
   * 若標題為空字串，則隱藏按鈕
   */
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set userCaption1(value: string) {
    this._userCaption1 = value;
    if (value === '') this.user1Visible = false;
    else this.user1Visible = true;
  }

  /**
   * 獲取自訂按鈕1標題
   */
  get userCaption1(): string {
    return this._userCaption1;
  }
  _userCaption2 = '自訂2';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set userCaption2(value: string) {
    this._userCaption2 = value;
    if (value === '') this.user2Visible = false;
    else this.user2Visible = true;
  }
  get userCaption2(): string {
    return this._userCaption2;
  }
  _userCaption3 = '自訂3';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set userCaption3(value: string) {
    this._userCaption3 = value;
    if (value === '') this.user3Visible = false;
    else this.user3Visible = true;
  }
  get userCaption3(): string {
    return this._userCaption3;
  }
  _userCaption4 = '自訂4';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set userCaption4(value: string) {
    this._userCaption4 = value;
    if (value === '') this.user4Visible = false;
    else this.user4Visible = true;
  }
  get userCaption4(): string {
    return this._userCaption4;
  }

  constructor() {
    super();
  }

  override ngOnInit() {
    // Add your implementation here
    super.ngOnInit();
  }


  /**
   * 根據實體狀態設定按鈕的啟用/停用狀態
   * @param state 實體狀態
   */
  setMode(state: entityState) {
    //this.state = state;
    if (state === entityState.dsBrowse) {
      this.insertDisabled = false;
      this.editDisabled = false;
      this.postDisabled = true;
      this.cancelDisabled = true;
      this.deleteDisabled = false;

      this.navigateVisible.set(true);
    } else {
      this.insertDisabled = true;
      this.editDisabled = true;
      this.postDisabled = false;
      this.cancelDisabled = false;
      this.deleteDisabled = true;

      this.navigateVisible.set(false);
    }
  }

  /**
   * 非同步設定導航區域可見性，避免 ExpressionChangedAfterItHasBeenCheckedError
   * @param visible 是否可見
   */
  private setNavigateVisibleOld(visible: boolean) {
    // 使用 setTimeout 將屬性修改延遲到下一個變更檢測週期
    setTimeout(() => {
      this.navigateVisible.set(visible);
    }, 0);
  }

  /**
   * 執行新增操作
   * @param $event 事件對象
   */
  async doInsert($event: any) {
    if (this.cbInsert) await this.cbInsert();
    //this.setMode(entityState.dsInsert);
  }

  /**
   * 執行編輯操作
   * @param $event 事件對象
   */
  doEdit($event: any) {
    if (this.cbEdit) this.cbEdit();
    //this.setMode(entityState.dsEdit);
  }

  /**
   * 執行儲存操作
   * @param $event 事件對象
   */
  async doPost($event: any) {
    if (this.cbPost) await this.cbPost($event);
    //this.setMode(entityState.dsBrowse);
  }

  /**
   * 執行取消操作
   * @param $event 事件對象
   */
  doCancel($event: any) {
    if (this.cbCancel) this.cbCancel();
    //this.setMode(entityState.dsBrowse);
  }

  /**
   * 執行刪除操作
   * @param $event 事件對象
   */
  async doDelete($event: any) {
    //if (confirm('是否刪除此筆資料?')) {
    if (this.cbDelete) {
      await this.cbDelete();// 需await?
      //this.setMode(entityState.dsBrowse);
    } else {
      alert('cbDelete is not defined');
    }
  }
  /**
   * 執行自訂按鈕1操作
   * @param $event 事件對象
   */
  user1($event: any) {
    if (this.cbUser1) this.cbUser1();
  }

  /**
   * 執行自訂按鈕2操作
   * @param $event 事件對象
   */
  user2($event: any) {
    if (this.cbUser2) this.cbUser2();
  }

  /**
   * 執行自訂按鈕3操作
   * @param $event 事件對象
   */
  user3($event: any) {
    if (this.cbUser3) this.cbUser3();
  }

  /**
   * 執行自訂按鈕4操作
   * @param $event 事件對象
   */
  user4($event: any) {
    if (this.cbUser4) this.cbUser4();
  }
  doHelp(): void {
    //this.login.host  http://localhost:4200/helpviewer?SH001=002&SH013=PACKAGE
    const url = window.location.origin + '/sys/helpviewer?SH001=' + this.programId.toUpperCase();// + '&SH013=' + this.login.userid;
    const w = window.open(
      url,
      '_blank',
      'menubar=no,status=no,scrollbars=no,top=0,left=0,toolbar=no',
    );
  }

}
